import React from "react";
import { Switch, Route, Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import RedCarpet2022 from "./RedCarpet2022";
import Event2022 from "./Event2022";
import Event2023 from "./Event2023";

const Intro = () => {
  const routes = [
    "/event-gallery/2022-red-carpet",
    "/event-gallery/2022-award-event",
    "/event-gallery/2023-awards",
  ];

  return (
    <Box>
      <Box sx={{ width: "100%", color: "#049593" }}>
        <Route
          path="/"
          render={(history) => (
            <Tabs
              value={
                history.location.pathname !== "/"
                  ? history.location.pathname
                  : false
              }
              variant="scrollable"
              scrollButtons="auto"
              textColor="#049593"
            >
              <Tab
                label="2022 Red Carpet"
                component={RouterLink}
                value={routes[0]}
                to={routes[0]}
                textColor="#D7A036"
              />
              <Tab
                label="2022 Award Ceremony"
                component={RouterLink}
                value={routes[1]}
                to={routes[1]}
                textColor="#D7A036"
              />
              <Tab
                label="2023 Award Ceremony"
                component={RouterLink}
                value={routes[3]}
                to={routes[2]}
                textColor="#D7A036"
              />
            </Tabs>
          )}
        ></Route>
        <Switch>
          <Route
            exact
            path="/event-gallery/2022-red-carpet"
            component={RedCarpet2022}
          />
          <Route path="/event-gallery/2022-award-event" component={Event2022} />
          <Route path="/event-gallery/2023-awards" component={Event2023} />
        </Switch>
      </Box>
    </Box>
  );
};

export default Intro;
